import { render, staticRenderFns } from "./ElButton.vue?vue&type=template&id=60b74cfb&scoped=true&"
import script from "./ElButton.vue?vue&type=script&lang=js&"
export * from "./ElButton.vue?vue&type=script&lang=js&"
import style0 from "./ElButton.vue?vue&type=style&index=0&id=60b74cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b74cfb",
  null
  
)

export default component.exports